var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackageSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f3e8ff;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7 {\n        stroke: #6b21a8;\n      }\n\n      .st0, .st1, .st4, .st6 {\n        stroke-width: 35px;\n      }\n\n      .st8 {\n        fill: #a78bfa;\n      }\n\n      .st9 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #d8b4fe;\n      }\n\n      .st1, .st4 {\n        stroke-linejoin: round;\n      }\n\n      .st10 {\n        stroke: #d8b4fe;\n      }\n\n      .st10, .st2, .st3, .st4, .st5, .st6, .st7 {\n        fill: none;\n      }\n\n      .st10, .st3 {\n        stroke-width: 45px;\n      }\n\n      .st2 {\n        stroke-width: 50px;\n      }\n\n      .st4, .st5, .st6, .st7 {\n        stroke-linecap: round;\n      }\n\n      .st5 {\n        stroke-width: 28px;\n      }\n\n      .st7 {\n        stroke-width: 15px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 380,
    y: 307.5,
    width: 480,
    height: 480,
    rx: 30,
    ry: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 402,
    y: 312.5,
    width: 440,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 398,
    y: 330.5,
    width: 440,
    height: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrows"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M600,627.5v80M570,657.5l30-30,30,30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M720,627.5v80M690,657.5l30-30,30,30"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 560,
    y1: 727.5,
    x2: 760,
    y2: 727.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M772,326v170l70-50v-120h-70Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "magnifier"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 381,
    cy: 340,
    r: 240
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 381,
    cy: 340,
    r: 200
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 381,
    cy: 340,
    r: 155
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 383.31,
    cy: 341,
    r: 130
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.16,302.91c-3.14-8.89,1.1-21.64,12.73-38.25,8.76-10.59,20.59-16.03,35.49-16.29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "handle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.14,497.49l-66.71,91.37c-11.12,15.23-18.43,33.24-21.93,54.03-1.24,13.68,3.85,24.7,15.28,33.04s23.47,9.83,36.12,4.49c18.73-9.67,33.66-22.12,44.78-37.35l66.71-91.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 192,
    y1: 530.21,
    x2: 162.82,
    y2: 570.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 175.33,
    y1: 553.06,
    x2: 146.14,
    y2: 593.03
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageSearch);
export default __webpack_public_path__ + "static/media/packageSearch.69a0c7d500eb2d5122176bc9f9d0074c.svg";
export { ForwardRef as ReactComponent };